export const columnLabels = {
  name: 'LCI Report Medium',
  visitMinimums:
    'Minimum Data Threshold for Visit Metrics (Per Dimension Of Data)',
  attributionMinimums:
    'Minimum Data Threshold for Attribution Metrics (Per Dimension Of Data)',
} as const;

export type MediumMinimums = Record<keyof typeof columnLabels, string>;
